<template>
    <div>
        <app-template>
            <!-- En-tête -->
            <template #header>
                <div class="page-header">
                    <h1 class="page-title">Paramètres</h1>
                    <p class="page-subtitle">Configuration et gestion des paramètres de l'application</p>
                </div>
            </template>

            <!-- Navigation par onglets -->
            <div class="tabs-wrapper">
                <nav class="tabs-nav">
                    <button
                        v-for="tab in tabs"
                        :key="tab.key"
                        class="tab-btn"
                        :class="{ active: selectedTab === tab.key }"
                        @click="selectedTab = tab.key"
                    >
                        <span class="tab-icon">
                            <i :class="tab.icon"></i>
                        </span>
                        <span class="tab-label">{{ tab.label }}</span>
                    </button>
                </nav>

                <!-- Sous-titre du composant actif -->
                <div class="tab-subtitle-bar">
                    <div class="tab-subtitle-content">
                        <h2 class="tab-title">{{ activeTab.label }}</h2>
                        <p class="tab-description">{{ activeTab.description }}</p>
                    </div>
                </div>

                <!-- Composant actif -->
                <div class="tab-content">
                    <component :is="activeTab.component" />
                </div>
            </div>
        </app-template>
    </div>
</template>

<script>
import ParametreCategorieAppareil from './ParametreCategorieAppareil.vue';
import ParametrePointControle from './ParametrePointControle.vue';
import ParametreTravaux from './ParametreTravaux.vue';
import TypeInterventionsConfig from './TypeInterventionsSettings.vue';
import ParametreTarifs from './ParametreTarifs.vue';

export default {
    components: {
        ParametreCategorieAppareil,
        ParametrePointControle,
        ParametreTravaux,
        TypeInterventionsConfig,
        ParametreTarifs
    },

    data() {
        return {
            selectedTab: 'categorie-appareil',
            tabs: [
                {
                    key: 'categorie-appareil',
                    label: 'Catégories d\'appareils',
                    description: 'Gérez les catégories d\'appareils proposées par votre société.',
                    icon: 'fas fa-cogs',
                    component: 'ParametreCategorieAppareil'
                },
                {
                    key: 'type-interventions',
                    label: 'Types d\'interventions',
                    description: 'Catégorisez et standardisez les interventions de votre entreprise.',
                    icon: 'fas fa-clipboard-list',
                    component: 'TypeInterventionsConfig'
                },
                {
                    key: 'travaux',
                    label: 'Travaux',
                    description: 'Les types de travaux permettent aux techniciens de préciser ce qu\'ils ont réalisé lors d\'une intervention.',
                    icon: 'fas fa-tools',
                    component: 'ParametreTravaux'
                },
                {
                    key: 'point-controle',
                    label: 'Points de contrôle',
                    description: 'Sélectionnez une catégorie puis un type d\'intervention pour gérer les points de contrôle.',
                    icon: 'fas fa-search',
                    component: 'ParametrePointControle'
                },
                {
                    key: 'tarifs',
                    label: "Contrat d'entretien",
                    description: 'Sélectionnez une catégorie puis un type d\'intervention pour gérer les tarifs.',
                    icon: 'fas fa-file-invoice',
                    component: 'ParametreTarifs'
                },
            ]
        };
    },

    computed: {
        activeTab() {
            return this.tabs.find(tab => tab.key === this.selectedTab);
        }
    }
};
</script>

<style scoped>
/* Page header */
.page-header {
    padding: 1.5rem 0 1rem;
}

.page-header .page-title {
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a1a2e;
    margin: 0 0 0.25rem;
}

.page-header .page-subtitle {
    font-size: 0.95rem;
    color: #6b7280;
    margin: 0;
}

/* Wrapper onglets */
.tabs-wrapper {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    overflow: hidden;
}

/* Nav onglets */
.tabs-nav {
    display: flex;
    border-bottom: 2px solid #f0f0f5;
    background: #fafafa;
    overflow-x: auto;
    scrollbar-width: none;
}

.tabs-nav::-webkit-scrollbar {
    display: none;
}

.tab-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.875rem 1.25rem;
    border: none;
    border-bottom: 2px solid transparent;
    background: transparent;
    cursor: pointer;
    white-space: nowrap;
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: -2px;
    transition: color 0.2s, border-color 0.2s, background 0.2s;
}

.tab-btn:hover {
    color: #374151;
    background: #f0f0f5;
}

.tab-btn.active {
    color: white;
    border-bottom-color: #EA580C;
    background: #EA580C;
}

.tab-btn .tab-icon {
    font-size: 1rem;
}

/* Barre sous-titre */
.tab-subtitle-bar {
    padding: 1rem 1.5rem;
    border-bottom: 1px solid #f0f0f5;
    background: #f8f8fc;
}

.tab-subtitle-content {
    display: flex;
    align-items: baseline;
    gap: 1rem;
    flex-wrap: wrap;
}

.tab-subtitle-bar .tab-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #1a1a2e;
    margin: 0;
}

.tab-subtitle-bar .tab-description {
    font-size: 0.85rem;
    color: #6b7280;
    margin: 0;
}

/* Contenu */
.tab-content {
    padding: 1.5rem;
}
</style>